import { GameV0 } from '@/types';
import React from 'react';
import classes from './GameProperties.module.css';
import { Game } from '../types/games_api_types';
import { timeToDayString, timeToTimeString } from '../utils';

export default function GameProperties({ game }: { game: Game }) {
  return (
    <div className={classes.gameProperties}>
      <div>
        <span>{timeToDayString({ time: game.start_time })}</span>
        <br />
        {game.time_tba ? (
          <span>TBA</span>
        ) : (
          <span>{timeToTimeString({ time: game.start_time })}</span>
        )}
        <br />
        <span>{game.tv_channel}</span>
      </div>
      <div className={classes.right}>
        {[game.event, game.sub_event, game.venue, game.location]
          .filter((item) => item != null)
          .map((item, index) => (
            <React.Fragment key={index}>
              <span>{item}</span>
              <br />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}
